export const salesTabs = ['MTD', 'YTD', 'LTD'];

export const posSalesDataContants = [
        {
            label:"LW BookScan",
            value:0
        },
        {
            label:"YTD BookScan",
            value:0
        },
        {
            label:"LTD BookScan",
            value:0
        }
    ]

    
    export const inventoryIndyConstants = [
        {
            label:"Indy Usable",
            value:"Total_Indy_Usable"
        },
        {
            label:"Indy Other",
            value:"Total_Indy_Other"
        },
        {
            label:"Indy Alloc",
            value:"Total_Indy_Alloc"
        },
        {
            label:"Indy Reserved",
            value:"Total_Reserved"
        },
        {
            label:"Indy BO Units",
            value:"Total_BO_Units"
        }
    ]

    export const inventoryOtherConstants = [
        {
            label:"UK Usable",
            value:"Total_UK_USABLE"
        },
        {
            label:"AUS Usable",
            value:"Total_AU_USABLE"
        },
    ]
